import React, { FC, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import NotAuthenticatedFormLayout from "@/components/layouts/NotAuthenticated/NotAuthenticatedFormLayout";
import { FlowSteps } from "@/components/molecules";
import { brokerApi } from "@/shared/apis";
import { useAuth, useNavigation } from "@/shared/hooks";
import * as tagManager from "@/tagManager";

import RegisterChooseBroker from "../Register/components/RegisterChooseBroker/RegisterChooseBroker";
import { AddABrokerSteps, stepperData } from "./utils";

const AddBroker: FC = () => {
    const { navToRoot } = useNavigation();
    const { user, changeBroker } = useAuth();
    const { t } = useTranslation();

    useEffect(() => {
        tagManager.pushAddBrokerEvent();
    }, []);

    const { mutate: addABroker } = useMutation(brokerApi.addABroker, {
        onSuccess: async (_, data) => {
            await changeBroker(data.officeId);
            navToRoot();
        },
    });

    const handleChooseBroker = (officeId: string) => {
        addABroker({
            officeId,
            policyHolderId: user.policyHolderId,
            accessRightId: user.accessControlListId,
        });
    };

    return (
        <>
            <NotAuthenticatedFormLayout
                title={t("MyBrokerSelector.AddBroker")}
                flowStepsComponent={
                    <FlowSteps
                        title={t("Registration.Steps.Title")}
                        availableSteps={stepperData}
                        currentStep={AddABrokerSteps.CHOOSE_BROKER}
                    />
                }
            >
                <RegisterChooseBroker confirmBrokerSelection={handleChooseBroker} />
            </NotAuthenticatedFormLayout>
        </>
    );
};

export default AddBroker;
